import { useRemoveBranchControlFromWorkflow } from '../../../components/Workflows/BranchControl/hooks/useRemoveBranchControlFromWorkflow';
import { useCloseDrawer } from '../actions/useCloseDrawer';
import { useOpenDrawer } from '../actions/useOpenDrawer';
import { useGetDrawer } from '../selectors/useGetDrawer';

export const useDrawer = () => {
  const openDrawer = useOpenDrawer();
  const closeDrawer = useCloseDrawer();
  const removeConfigNode = useRemoveBranchControlFromWorkflow();

  const drawer = useGetDrawer();

  return { openDrawer, closeDrawer, removeConfigNode, drawer };
};
